import React from 'react';
import intl from 'react-intl-universal';
import { RowInfo } from 'react-table';
import { BASE_ROOM_SYSTEM_ROUTE } from 'constants/roomSystemConstants';
import { getSystemNameDisplayText } from 'utils/roomSystemUtils';
import { Link } from 'react-router-dom';
import * as styles from './DisplayNameCell.scss';

interface Props {
  row: RowInfo;
}

const DisplayNameCell = ({ row }: Props) => {
  const { displayName, isTrial } = row.original;
  return (
    <span>
      {
        displayName &&
        <>
          <Link
            id={`settings-${displayName}`}
            title={intl.get('system-details')}
            to={`${BASE_ROOM_SYSTEM_ROUTE}/${row.original.serialNumber}`}
          >
            {getSystemNameDisplayText(displayName)}
          </Link>
          <div className={styles.statusContainer}>
            {isTrial ? (
              <div className={styles.trialContainer}>
                <span className={styles.trialText}>
                  {intl.get('trial')}
                </span>
              </div>
            ) : null}
          </div>
        </>
      }
    </span>
  );
};

export default DisplayNameCell;
